export function registerSnackbarOnSubmit(): void {
  const form = document.getElementById('snackbarForm') as HTMLFormElement;
  const snackbar = document.getElementById('snackbar');

  if (form && snackbar) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      // Serialize form data
      const formData = new FormData(form);

      // Send form data using AJAX
      const xhr = new XMLHttpRequest();
      xhr.open('POST', form.action);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function() {
        if (xhr.status === 200) {
          // Show the snackbar
          snackbar.classList.remove('hidden');

          // Center the snackbar vertically
          const windowHeight = window.innerHeight;
          const snackbarHeight = snackbar.offsetHeight;
          const topOffset = (windowHeight - snackbarHeight) / 2;

          // Fade in the snackbar
          snackbar.style.opacity = '0';

          requestAnimationFrame(() => {
            snackbar.style.transition = 'opacity 0.3s ease-out';
            snackbar.style.opacity = '1';
          });

          // Hide the snackbar after 3 seconds
          setTimeout(() => {
            // Fade out the snackbar
            snackbar.style.opacity = '0';

            // Hide the snackbar after the transition
            setTimeout(() => {
              snackbar.classList.add('hidden');
              snackbar.style.transition = '';
              snackbar.style.opacity = '';
              snackbar.style.top = '';
            }, 300);
          }, 5000);
        }
      };
      xhr.send(formData);
    });
  }
}